module.exports = __webpack_public_path__ + "static/media/babel.5e61d42f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/babel.png
// module id = 72
// module chunks = 0